import type { MinifiedGlobalPageSettings } from '~~/lib/ContentfulGraphqlService';
import { getCheckoutPageSlugs } from '~/utils/shop/getShopContextSlugs';

export default function isOneOfCheckoutPages(
  $globalPageSettings: Ref<MinifiedGlobalPageSettings | null>,
  slug: Ref<string>
) {
  return getCheckoutPageSlugs($globalPageSettings.value?.shopConfig).includes(
    slug.value
  );
}
